module.exports = __webpack_public_path__ + "img/IntuitSignIn-lg-white@2x.e155f2ef.jpg";